import services from '.'
import { IData, IEnumExamType, IExam } from '../@types'
import { getAxiosErrorMessage } from '../resources'

const basePath = '/assessments'

interface ICreateAssessmentResponse {
  id: string
  uploadUrls: string[]
}

async function create(
  payload: unknown,
): Promise<Pick<ICreateAssessmentResponse, 'uploadUrls'>> {
  try {
    const { data } = await services.api.post<IData<ICreateAssessmentResponse>>(
      basePath,
      payload,
    )

    return { uploadUrls: data.data?.uploadUrls ?? [] }
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function createQuestion(payload: unknown): Promise<string | undefined> {
  try {
    const { data } = await services.api.post<IData<IExam>>(
      `${basePath}/questions/`,
      payload,
    )
    return data.data?.id
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getAll(): Promise<Array<IExam> | undefined> {
  try {
    const assessments = await services.api
      .get<IData<Array<IExam>>>(basePath)
      .then(({ data }) => data?.data)

    const sorted = assessments?.sort((a, b) => {
      const aDate = new Date(a.updatedAt)
      const bDate = new Date(b.updatedAt)

      return bDate.getDate() - aDate.getDate()
    })

    return sorted
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getByType(
  type: IEnumExamType,
): Promise<Array<IExam> | undefined> {
  try {
    const assessments = await services.api
      .get<IData<Array<IExam>>>(basePath + `?type=${type}`)
      .then(({ data }) => data?.data)

    return assessments
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getByID(id: string): Promise<IExam | undefined> {
  try {
    const { data } = await services.api.get<IData<IExam>>(
      `${basePath}?id=${id}`,
    )
    return data?.data
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function deleteById(id: string): Promise<void> {
  try {
    await services.api.delete(`${basePath}/${id}`)
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

export default {
  getAll,
  deleteById,
  getByType,
  create,
  createQuestion,
  getByID,
}
